module.exports = __webpack_public_path__ + "img/workflow_3.3f05fa00.jpg";